module.exports = __webpack_public_path__ + "img/t5-i2.e00d8752.svg";